import map from 'lodash/map';
import moment from 'moment';
import React from 'react';
import {connect} from 'react-redux';
import Loader from '../../../../../components/Loader';
import {getUberEatsUsersByGameWeek} from '../../../../../actions/entities/uberEats';
import './index.css';

class UberEatsPlayersPerWeekWidget extends React.Component {
  constructor(props) {
    super(props);

    const today = new Date();
    const end = moment(today.setDate(today.getDate())).format('YYYY-MM-DD');

    this.state = {end, lang: 'ALL'};
  }

  fetchStats() {
    this.props.dispatch(getUberEatsUsersByGameWeek(), null, this.onError);
  }

  static orderTable(table) {
    // No order for this widget
    return table;
  }

  renderTable() {
    const {gameWeek, isFetching} = this.props;
    const table = gameWeek?.data?.gameWeeks;

    if (!table) return false;

    return (
      !isFetching &&
      table && (
        <div className="mt-3 table-responsive">
          <table className="table table-striped">
            <thead>
              <tr className="bg-gray">
                <th className="name">Journée</th>
                <th className="text-center">Nb de joueurs</th>
              </tr>
            </thead>
            <tbody>
              {map(table, (item, index) => {
                return (
                  <tr
                    key={`${index}`}
                    data-toggle="collapse"
                    data-target={`.${index}`}>
                    <td className="name">
                      <b>{item.name}</b>
                      <div className={`${index} collapse`}>
                        {map(item.matches, match => (
                          <div className="match-container">
                            <div className="text-right match">
                              {match.homeName}
                            </div>
                            <div className="match-container match">-</div>
                            <div className="text-left match">
                              {match.awayName}
                            </div>
                          </div>
                        ))}
                      </div>
                    </td>
                    <td className="text-center users">
                      <b>{item.users}</b>
                      <div className={`${index} collapse`}>
                        {map(item.matches, match => (
                          <div className="match-container">{match.users}</div>
                        ))}
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )
    );
  }

  render() {
    const {end} = this.state;
    const {isFetching, gameWeek} = this.props;
    const totalUsers = gameWeek?.data?.totalUsers || 0;

    return (
      <div id="players-per-week-stats-widget">
        <div className="box">
          <div className="box-header with-border">
            <h3 className="box-title pull-left">
              <i className="fa fa-trophy" /> Players per gameweek
            </h3>
            <br />
          </div>
          <div className="box-body">
            <h4 className="box-title pull-right">
              Nombre total de joueurs uniques : {totalUsers}
            </h4>
            <br />
            <button
              className="mr-4 inline btn btn-default"
              onClick={() => this.fetchStats()}>
              <i className="fa fa-refresh" />
            </button>
            {moment(end).format('DD/MM/YYYY')}
          </div>
          {isFetching && <Loader />}
          {this.renderTable()}
        </div>
      </div>
    );
  }
}

export default connect(
  state => ({
    gameWeek: state.app.uberEats.gameWeek,
  }),
  dispatch => ({dispatch}),
)(UberEatsPlayersPerWeekWidget);



// WEBPACK FOOTER //
// ./src/pages/UberEats/Stats/Widgets/PlayersPerWeek/index.js